const state = {
  all: [],
  availableRooms: [],
  availableBuildings: [],
  selectedRooms: [],
  selectedReservations: []
}

const getters = {}

const actions = {
  validateSatsangi({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios
        .post("/validateSatsangi", params , {
            headers: {
              'Content-Type': 'application/json',
            }
          })
        .then(response => {resolve(response)})
        .catch ( error => (reject(error)));
    })
  },
  getReservations ({ commit }) {
    axios
      .get("/admin/reservations")
      .then(response => (commit('setReservations', response.data)));
  },
  searchAvailableRooms ({ commit }, params) {
    axios
      .get("/admin/rooms/available", {params: params})
      .then(response => (commit('setAvailableRooms', response.data.data)))
  },
  getSelectedRooms ({ commit }, params) {
    axios
      .get("/admin/reservations/"+params.id+"/rooms")
      .then(response => (commit('setSelectedRooms', response.data.data)));
  },
  setStatusHoldAutoPayment({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios
        .put("/admin/reservations/"+params.id+"/status/holdautopayment", params)
        .then(response => {resolve(response)})
        .catch ( error => (reject(error)));
    })
  },
  setReservationBuilding({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios
        .put("/admin/reservations/"+params.reservation_id+"/building", params)
        .then(response => {resolve(response)})
        .catch ( error => (reject(error)));
    })
  },
  setStatusHold ({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios
        .put("/admin/reservations/"+params.id+"/status/hold", params)
        .then(response => {resolve(response)})
        .catch ( error => (reject(error)));
    })
  },
  setStatusPaid ({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios
        .put("/admin/reservations/"+params.id+"/status/paid", params)
        .then(response => {resolve(response)})
        .catch ( error => (reject(error)));
    })
  },
  setAutoRooms ({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios
        .put("/admin/reservations/"+params.id+"/rooms/auto", params)
        .then(response => {resolve(response)})
        .catch ( error => (reject(error)));
    })
  },
  setManualRoom ({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios
        .put("/admin/reservations/" + params.reservation_id +"/editReservation", params)
        .then(response => {resolve(response)})
        .catch ( error => (reject(error)));
    })
  },
  setMultipleAutoRooms ({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios
        .post("/admin/reservations/multiple/auto", params)
        .then(response => {resolve(response)})
        .catch ( error => (reject(error)));
    })
  },
  updateCheckinReservation({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios
        .post("/admin/reservations/updateCheckinReservation", params)
        .then(response => {resolve(response)})
        .catch ( error => (reject(error)));
    })
  },
  setMultipleManualRooms ({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios
        .post("/admin/reservations/multiple/manual", params)
        .then(response => {resolve(response)})
        .catch ( error => (reject(error)));
    })
  },
  deleteReservation ({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios
        .delete("/admin/reservations/"+params.id, params)
        .then(response => {resolve(response)})
        .catch ( error => (reject(error)));
    })
  },
  createReservation ({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios
        .post("/reservations", params)
        .then(response => {resolve(response)})
        .catch ( error => (reject(error)));
    })
  },
  adminCreateReservation ({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios
        .post("/admin/reservations", params)
        .then(response => {resolve(response)})
        .catch ( error => (reject(error)));
    })
  }
}

const mutations = {
  setReservations (state, data) {
    state.all = data.data;
  },
  setAvailableRooms (state, rooms) {
    state.availableRooms = rooms;
    let buildings = []
    _.each(rooms, (room) => {
      let building = _.find(buildings, (building) => building.id == room.floor.building.id)
      if (!building) {
        building = {
          id: room.floor.building.id,
          name: room.floor.building.name,
          floors: [],
          avail_rooms: 0,
          total_rooms: room.floor.building.total_rooms
        }
        buildings.push(building)
      }

      let floor = _.find(building.floors, (floor) => floor.id == room.floor.id)

      if (!floor ) {
        floor = {
          id: room.floor.id,
          floor_number: room.floor.floor_number,
          rooms: []
        }
        building.floors.push(floor)
      }

      floor.rooms.push(room)
      building.avail_rooms++
    })
    state.availableBuildings = buildings
  },

  clearAvailableRooms (state) {
    state.availableRooms = []
    state.availableBuildings = []
  },
  setSelectedRooms (state, rooms) {
    state.selectedRooms = rooms;
  },
  setSelectedReservations (state, reservations) {
    state.selectedReservations = reservations;
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
